//Dependencies............................................
import React from "react";
import {Button, Form, Input, Modal} from 'antd';

//Components..............................................
import {User} from "utils/interfaces";
import { Control, Controller, FieldErrors, SubmitHandler, UseFormHandleSubmit } from "react-hook-form";

interface Props {
    showAddUserModal: boolean,
    toggleAddUserModal: () => void,
    userAddErrors: FieldErrors<User>,
    userAddControl: Control<User, any, User>,
    onSubmit: SubmitHandler<User>,
    userAddHandleSubmit: UseFormHandleSubmit<User, User>,
    isValid: boolean,
    isSubmitting: boolean,
}



const AddUserModal: React.FC<Props> = ({
    showAddUserModal,
    toggleAddUserModal,
    userAddErrors,
    userAddControl,
    userAddHandleSubmit,
    onSubmit,
    isValid,
    isSubmitting
}: Props) => {

    return(
        <Modal
            open={showAddUserModal}
            onCancel={toggleAddUserModal}
            title="Add Service Account"
            closable={!isSubmitting}
            mask={{ closable: !isSubmitting }}
            footer={[
                <Button type="default" onClick={toggleAddUserModal} disabled={isSubmitting}>Close</Button>,
                <Button
                    type="primary"
                    onClick={userAddHandleSubmit(onSubmit)}
                    disabled={!isValid || isSubmitting}
                    loading={isSubmitting}
                >Save Changes</Button>
            ]}
        >
            <p>
                This creates an API-key-only account (for a mobile app or another server) - it can't sign in.
                Users who sign in with Azure are added automatically the first time they log in.
            </p>
            <Form layout="vertical" preserve={false}>
                <Form.Item
                    label="Identifier"
                    validateStatus={userAddErrors.user_email ? "error" : ""}
                    help={userAddErrors.user_email?.message || "A short name for this account - it doesn't need to be a real email."}
                >
                    <Controller
                        name="user_email"
                        control={userAddControl}
                        rules={{ required: "Identifier is required" }}
                        render={({field}) => (
                            <Input
                                {...field}
                                placeholder="Enter an identifier, e.g. mobile-app"
                            />
                        )}
                    />
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default AddUserModal;
